import React from 'react';
import {useTranslation} from 'react-i18next';
import ConfirmBookingDetailsForm from 'components/ConfirmBookingDetailsForm';
import CheckinNavigation from 'components/acommon/CheckinNavigation';
import DetailsWrapper from 'components/acommon/DetailsWrapper';
import BookingDetails from 'components/acommon/BookingDetails';
import Page from 'components/acommon/Page';
import styles from './ConfirmBookingDetailsScreen.module.sass';

function ConfirmBookingDetailsScreen() {
  const {t} = useTranslation();

  return (
    <Page showFooterOnlyMobile paddingBottomMobileFooter>
      <CheckinNavigation title={t('confirm_your_booking_details')} />
      <div className={styles.container}>
        <div className={styles.details}>
          <DetailsWrapper>
            <BookingDetails />
          </DetailsWrapper>
        </div>
        <ConfirmBookingDetailsForm />
      </div>
    </Page>
  );
}

export {ConfirmBookingDetailsScreen};
